
export const dummyData = {
    projectName: "Vedic Lifestyle",
    dummyProjects: [
        { label: "Vedic Lifestyle", value: "p1" }
    ],
    lastUpdated: "6.55pm",
    date: "12 Jan 2026",
    todayProgress: {
        percentage: 50,
        trend: 12,
        description: "Foundation work is on track with 4/8 planned tasks completed. Electrical rough-in progressing ahead of schedule."
    },
    overallProgress: {
        percentage: 85,
        status: "Complete"
    },
    stageColors: ["#1F4B55", "#E3C86F", "#7FA0A5", "#FF7676", "#1F4B55"],
    stages: [
        { name: "Foundation", percentage: 95, color: "#1F4B55" }, // Dark Green/Teal
        { name: "Structural", percentage: 78, color: "#1F4B55" },
        { name: "MEP Rough- in", percentage: 63, color: "#E3C86F" }, // Yellow/Gold
        { name: "Interior Walls", percentage: 45, color: "#7FA0A5" }, // Muted Blue/Green
        { name: "Finishes", percentage: 18, color: "#E3C86F" },
        { name: "External Works", percentage: 12, color: "#FF7676" }, // Red/Pink
    ],
    todaysWork: {
        inProgress: [
            {
                id: 1,
                name: "Foundation concrete pouring- Block A (East Wing)",
                count: 4,
                plannedDate: "Dec 10",
                endDate: "Dec 21",
                duration: "12 Days",
                assigned: {
                    engineers: [{ name: "Engineer", initials: "E" }],
                    contractors: [],
                    architects: [{ name: "Architect", initials: "A" }],
                    operations: [{ name: "Operation Manager 2", initials: "O" }]
                },
                subActivities: [
                    { name: "Excavate Trenches", status: "completed" },
                    { name: "Prepare Base", status: "completed" },
                    { name: "Reinforcement & Formwork", status: "completed" },
                    { name: "Pour Concrete Footings", status: "in-progress" },
                    { name: "Curing", status: "pending" },
                    { name: "Idle Time - 1Day", status: "pending" }
                ],
                dependency: "Site Preparation",
                drawingRequired: "Yes",
                budget: {
                    labour: 100,
                    material: 100
                }
            },
            {
                id: 2, name: "Rebar installation - 3rd floor columns",
                plannedDate: "Jan 05",
                endDate: "Jan 15",
                duration: "10 Days",
                assigned: {
                    engineers: [{ name: "Rajesh", initials: "R" }],
                    contractors: [{ name: "Civil Corp", initials: "C" }],
                    architects: [],
                    operations: []
                },
                subActivities: [
                    { name: "Cut Rebars", status: "completed" },
                    { name: "Bend Rebars", status: "in-progress" },
                    { name: "Place Rebars", status: "pending" }
                ],
                dependency: "Formwork",
                drawingRequired: "Yes",
                budget: {
                    labour: 500,
                    material: 1200
                }
            },
            {
                id: 3, name: "Plumbing rough - in - G Floor bathrooms",
                plannedDate: "Jan 10",
                endDate: "Jan 12",
                duration: "2 Days",
                assigned: {
                    engineers: [],
                    contractors: [{ name: "PlumbFast", initials: "P" }],
                    architects: [],
                    operations: []
                },
                subActivities: [],
                dependency: "Walls",
                drawingRequired: "No",
                budget: {
                    labour: 200,
                    material: 300
                }
            },
            {
                id: 4, name: "Wall framing- Units: 101- 104",
                plannedDate: "Jan 11",
                endDate: "Jan 18",
                duration: "7 Days",
                assigned: {
                    engineers: [{ name: "Alice", initials: "A" }],
                    contractors: [],
                    architects: [],
                    operations: []
                },
                subActivities: [],
                dependency: "Floor",
                drawingRequired: "Yes",
                budget: {
                    labour: 800,
                    material: 400
                }
            },
        ],
        completed: [
            {
                id: 5,
                name: "Excavation and PCC - Block A",
                plannedDate: "Dec 01",
                endDate: "Dec 09",
                duration: "8 Days",
                assigned: {
                    engineers: [{ name: "Karan", initials: "K" }],
                    contractors: [{ name: "EarthWorks", initials: "EW" }],
                    architects: [],
                    operations: []
                },
                subActivities: [{ name: "All Tasks", status: "completed" }],
                dependency: "None",
                drawingRequired: "Yes",
                budget: { labour: 150, material: 200 }
            },
            {
                id: 6,
                name: "Rebar installation - 2nd floor slab",
                plannedDate: "Dec 15",
                endDate: "Dec 20",
                duration: "5 Days",
                assigned: {
                    engineers: [],
                    contractors: [{ name: "IronWorks", initials: "IW" }],
                    architects: [],
                    operations: []
                },
                subActivities: [],
                dependency: "None",
                drawingRequired: "No",
                budget: { labour: 300, material: 600 }
            }
        ]
    },
    delayedTasks: {
        haventStarted: [
            {
                id: 1,
                name: "Pipe pressure testing - 2nd floor bathrooms",
                type: "error",
                plannedDate: "Jan 12",
                endDate: "Jan 14",
                duration: "2 Days",
                assigned: {
                    engineers: [{ name: "Site Eng 1", initials: "SE" }],
                    contractors: [{ name: "Plumbing Co", initials: "P" }],
                    architects: [],
                    operations: []
                },
                subActivities: [
                    { name: "Seal Pipes", status: "completed" },
                    { name: "Pressure Test", status: "pending" },
                    { name: "Check Leaks", status: "pending" }
                ],
                dependency: "Plumbing Rough-in",
                drawingRequired: "Yes",
                budget: {
                    labour: 150,
                    material: 50
                }
            },
            {
                id: 2,
                name: "Pipe pressure testing - 2nd floor bathrooms",
                type: "error",
                plannedDate: "Jan 12",
                endDate: "Jan 14",
                duration: "2 Days",
                assigned: {
                    engineers: [{ name: "Site Eng 1", initials: "SE" }],
                    contractors: [{ name: "Plumbing Co", initials: "P" }],
                    architects: [],
                    operations: []
                },
                subActivities: [],
                dependency: "Plumbing Rough-in",
                drawingRequired: "Yes",
                budget: { labour: 150, material: 50 }
            }
        ],
        workStopped: [
            {
                id: 3,
                name: "Pipe pressure testing - 2nd floor bathrooms",
                type: "warning",
                plannedDate: "Jan 12",
                endDate: "Jan 14",
                duration: "2 Days",
                assigned: {
                    engineers: [{ name: "Site Eng 1", initials: "SE" }],
                    contractors: [{ name: "Plumbing Co", initials: "P" }],
                    architects: [],
                    operations: []
                },
                subActivities: [],
                dependency: "Plumbing Rough-in",
                drawingRequired: "Yes",
                budget: { labour: 150, material: 50 }
            }
        ]
    },
    accountability: [
        { id: 1, role: "Site Engineer", name: "Rajesh Sharma", initials: "RS" },
    ],
    materialStatus: [
        { name: "Cement", stock: "280 Bags", status: "Available" },
        { name: "Steel Rebar", stock: "10 Tons", status: "Available" },
        { name: "Cement", stock: "280 Bags", status: "Critical" },
        { name: "Steel Rebar", stock: "10 Tons", status: "Low" },
        { name: "Steel Rebar", stock: "10 Tons", status: "Low" },
    ],
    delaysAndAlerts: [
        {
            id: 1,
            title: "Concrete supply delay",
            description: "Supplier truck breakdown, alternate supplier arranged",
            person: "Ramesh Kumar (Contractor)",
            type: "Critical"
        },
        {
            id: 2,
            title: "Inspection pending- Floor 7",
            description: "Municipal inspector not available until tomorrow",
            person: "Priya Sharma (Engineer)",
            type: "Low"
        }
    ],
    quickSummary: {
        text: "Overall productivity improved today with steady structural progress and minor delays in facade work.",
        tomorrowsPlan: [
            "Complete concrete pouring for Column C12",
            "Start electrical cable tray installation",
            "Finish plumbing pressure testing",
            "Begin facade glass fixing"
        ]
    },
    photoProof: [
        { id: 1, title: "Block B - Excavation Work", time: "2026-02-03T09:30:00", url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1iRfy6y3LJ6aKi-bWxc881-6SNmcp9nn6PQ&s" },
        { id: 2, title: "Tower A - 2nd Floor Slab", time: "2026-02-03T11:45:00", url: "https://i.pinimg.com/736x/5e/60/40/5e604013b59a62abff49bacb2dc2b922.jpg" },
        { id: 3, title: "Material Unloading", time: "2026-02-03T14:15:00", url: "https://media.istockphoto.com/id/688591746/photo/dumptruck-in-action.jpg?s=612x612&w=0&k=20&c=pyQNwmDm4UNzT9rvYMPwCLk4NP-7_K6rmo5SZycuF6Q=" },
        { id: 4, title: "Site Perimeter Fencing", time: "2026-02-03T16:50:00", url: "https://5.imimg.com/data5/SELLER/Default/2025/3/493604516/UF/AU/SO/21047379/construction-site-safety-fence.jpg" },
    ]
};
